import React from 'react';
import { Text } from '@spark';
import CostConfigPopover from './CostConfigPopover';

const titleCase = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

const formatCostText = ({ instanceType = 'persistent', costValue, period, lifecycle }) => {
  const periodWord = period === 'hourly' ? 'per hour' : period === 'daily' ? 'per day' : 'per month';
  const lifecycleWord = lifecycle === 'spot' ? 'Spot' : 'On-Demand';
  return `Estimated cost for ${titleCase(instanceType)} (${lifecycleWord}) instance is: $${costValue} ${periodWord}`;
};

/**
 * Light-blue banner stating the estimated cost, with the "Cost
 * configuration" trigger anchored to the right side of the banner.
 *
 * Used in single-environment view. In multi-environment (Infrastructure
 * Comparison) view there is no banner, so the popover lives in
 * `PerformanceFiltersRow` next to "Filter Metrics" instead.
 *
 * @param {Object} props
 * @param {('persistent'|'serverless')} props.instanceType
 * @param {number} props.costValue
 * @param {import('./data/performanceMetricsApi').CostConfig} props.costConfig
 * @param {(next: import('./data/performanceMetricsApi').CostConfig) => void} props.onChangeCostConfig
 */
export default function CostBanner({ instanceType, costValue, costConfig, onChangeCostConfig }) {
  if (costValue == null) {
    return null;
  }
  const text = formatCostText({
    instanceType,
    costValue,
    period: costConfig?.period,
    lifecycle: costConfig?.lifecycle,
  });

  return (
    <div
      className="fs-unmask"
      style={{
        background: '#EFF6FF',
        border: '1px solid #DBEAFE',
        borderRadius: 8,
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 24,
        gap: 12,
      }}
    >
      <Text variant="base-regular" style={{ color: '#1E3A8A' }}>
        {text.split(': ').map((segment, idx, arr) =>
          idx === arr.length - 1 ? (
            <span key={idx}>
              {idx > 0 ? ': ' : ''}
              <strong>{segment}</strong>
            </span>
          ) : (
            <span key={idx}>{segment}</span>
          )
        )}
      </Text>
      <CostConfigPopover value={costConfig} onChange={onChangeCostConfig} />
    </div>
  );
}
